var now = new Date() // 当前日期
var nowDayOfWeek = now.getDay() // 今天本周的第几天
var nowDay = now.getDate() // 当前日
var nowMonth = now.getMonth() // 当前月
var nowYear: any = now.getFullYear() // 当前年

var DateUtil = {
  /**
   * 获得当前日期
   *
   * @returns
   */
  getNowDay: function () {
    return this.formatDate(now)
  },
  getNowDayTime: function () {
    var now = new Date()
    return this.formatDate(now) + ' ' + this.gormatDateAndTime(now)
  },
  getTimeForDate: function (dataObj) {
    var now = new Date(dataObj)
    return this.formatDate(now) + ' ' + this.gormatDateAndTime(now)
  },
  /**
   * 获得本周的开始时间
   *
   * @returns
   */
  getStartDayOfWeek: function () {
    var day = nowDayOfWeek || 7
    return this.formatDate(new Date(nowYear, nowMonth, nowDay + 1 - day))
  },
  /**
   * 获得本周的结束时间
   *
   * @returns
   */
  getEndDayOfWeek: function () {
    var day = nowDayOfWeek || 7
    return this.formatDate(new Date(nowYear, nowMonth, nowDay + 7 - day))
  },
  /**
   * 获得本月的开始时间
   *
   * @returns
   */
  getStartDayOfMonth: function () {
    var monthStartDate = new Date(nowYear, nowMonth, 1)
    return this.formatDate(monthStartDate)
  },
  /**
   * 获得本月的结束时间
   *
   * @returns
   */
  getEndDayOfMonth: function () {
    let monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays())
    return this.formatDate(monthEndDate)
  },
  /**
   * 获得某一天的那个月的结束时间
   *
   * @returns
   */
  getEndDayOfDayThatMonth: function (dataObj) {
    var now = new Date(dataObj)
    var nowMonth = now.getMonth() // 当前月
    var nowYear: any = now.getFullYear() // 当前年
    var monthStartDate: any = new Date(nowYear, nowMonth, 1)
    var monthEndDate: any = new Date(nowYear, nowMonth + 1, 1)
    var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
    return this.formatDate(new Date(nowYear, nowMonth, days))
  },
  /**
   * 获得本月天数
   *
   * @returns
   */
  getMonthDays: function () {
    var monthStartDate: any = new Date(nowYear, nowMonth, 1)
    var monthEndDate: any = new Date(nowYear, nowMonth + 1, 1)
    var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
    return days
  },
  /**
   * @param 日期格式化
   * @returns {String}
   */
  formatDate: function (date: Date) {
    var y = date.getFullYear()
    var m = (date.getMonth() + 1).toString().padStart(2, '0')
    var d = date
      .getDate()
      .toString()
      .padStart(2, '0')
    return `${y}-${m}-${d}`
  },
  /**
   * @param 时间格式化
   * @returns {String}
   */
  gormatDateAndTime: function (date: Date) {
    var h = date
      .getHours()
      .toString()
      .padStart(2, '0')
    var m = date
      .getMinutes()
      .toString()
      .padStart(2, '0')
    var s = date
      .getSeconds()
      .toString()
      .padStart(2, '0')
    return `${h}:${m}:${s}`
  },
  /**
   * @param 时间格式化
   * @returns {String}
   */
  getLastMonth: function (dataObj = new Date()) {
    var year, lastMonth
    var date = new Date(dataObj)
    var nowYear = date.getFullYear() // 当前年：四位数字
    var nowMonth = date.getMonth() // 当前月：0-11
    if (nowMonth == 0) { // 如果是0，则说明是1月份，上一个月就是去年的12月
      year = nowYear - 1
      lastMonth = 12
    } else { // 不是1月份，年份为当前年，月份本来是要减1的，但是由于`getMonth()`的月份本身就是少了1的，所以月份不用变。
      year = nowYear
      lastMonth = nowMonth
    }
    lastMonth = lastMonth < 10 ? ('0' + lastMonth) : lastMonth // 月份格式化：月份小于10则追加个0
    let lastYearMonth = year + '-' + lastMonth
    return lastYearMonth
  },
  /**
   * 根据日期字符串获取星期几
   * @param dateString 日期字符串（如：2021-12-08）
   * @returns {String}
   */
  getWeek: function (dateString) {
    let dateArray = dateString.split('-').map(item => Number(item))
    let date = new Date(dateArray[0], parseInt(String(dateArray[1] - 1)), dateArray[2])
    return '周' + '日一二三四五六'.charAt(date.getDay())
  }
}

export default DateUtil
